import { normalizeSubjectName } from '../../utils/categoryCourses';

const ALL_TAB = 'all';

function TabDivider() {
  return <span className="mx-1 h-5 w-px bg-[#D9D9D9] sm:mx-2" aria-hidden />;
}

export default function SubjectFilterTabs({ subjects, activeSubjectId, onChange, loading }) {
  const tabs = [
    { id: ALL_TAB, name: 'All' },
    ...subjects.map((subject) => ({
      id: String(subject.id),
      name: normalizeSubjectName(subject.name),
    })),
  ];

  return (
    <div className="mx-auto max-w-4xl rounded-2xl bg-white px-3 py-3 shadow-[0_8px_30px_rgba(0,0,0,0.08)] sm:px-6">
      <div className="flex flex-wrap items-center justify-center gap-1 sm:gap-0">
        {loading ? (
          <p className="px-4 py-2 text-sm text-[#666666]">Loading subjects...</p>
        ) : (
          tabs.map((tab, index) => {
            const isActive = activeSubjectId === tab.id;

            return (
              <div key={tab.id} className="flex items-center">
                {index > 0 && <TabDivider />}
                <button
                  type="button"
                  onClick={() => onChange(tab.id)}
                  className={`relative px-3 py-2 text-sm font-semibold transition sm:px-5 sm:text-base ${
                    isActive ? 'text-[#1A87CC]' : 'text-[#666666] hover:text-[#1A87CC]'
                  }`}
                >
                  {tab.name}
                  {isActive && (
                    <span className="absolute bottom-0 left-3 right-3 h-0.5 rounded-full bg-[#1A87CC] sm:left-5 sm:right-5" />
                  )}
                </button>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

export { ALL_TAB };
